export default __webpack_public_path__ + "static/media/Bur.c6d2228c.svg";